import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { createSearchParams, useNavigate } from "react-router-dom";
import { Axios } from "../../../Axios";
import { BASE_URL } from "../../../Axios/base_url";
import { subItems } from "../../../assets/svgIcons";
import UseGeneral from "../../../hooks/useGeneral";
import "./style.css";
const BottomHeader = ({ setIsSticky }) => {
  const { language } = UseGeneral();
  const navigate = useNavigate();
  const [headerLoading, setHeaderLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const getCategories = () => {
    setHeaderLoading(true);
    if (
      localStorage.getItem("greenTreesSiteCategories") &&
      localStorage.getItem("greenTreesSiteCategories") != null &&
      localStorage.getItem("greenTreesSiteCategories") != "undefined" &&
      localStorage.getItem("greenTreesSiteCategories") != undefined
    ) {
      try {
        const data = JSON.parse(
          localStorage.getItem("greenTreesSiteCategories")
        );
        setCategories((prev) => data);
      } catch (e) {
        ;
      }
    }
    Axios({
      url: BASE_URL + "categories/get_all",
      method: "GET",
    })
      .then((res) => {
        ;
        if (Array.isArray(res.result)) {
          localStorage.setItem(
            "greenTreesSiteCategories",
            JSON.stringify(res.result)
          );
          setCategories((prev) => res.result);
        }
        if (res.status == "success") {
        }
      })
      .finally(() => {
        setHeaderLoading(false);
      });
  };
  useEffect(() => {
    getCategories();
  }, []);
  return (
    <div className="rowDiv">
      <div className="categories">
        <Dropdown className="main_drop">
          <Dropdown.Toggle
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              cursor: "pointer",
              border: "none",
              padding: 0,
            }}
            variant=""
            id="dropdown-basic"
            onClick={()=>window.location.href = "/Categories"}
          >
            {language == "ar" ? (
              <div className="d-flex all_categories">
                <img
                  src={require("../../../assets/Vector.png")}
                  alt=""
                  // style={{ margin: "0 10px" }}
                />
                <span className="category cat">الأقسام</span>
              </div>
            ) : (
              <div className="d-flex all_categories">
                <img src={require("../../../assets/Vector.png")} alt="" />
                <span className="category">All Categories</span>
              </div>
            )}
          </Dropdown.Toggle>
          <div className="sub_category_drop">
            <div className="sub_sub_category_drop">
            {categories && categories?.length
              ? categories?.map((itemCat, index) => {
                  if (true) {
                    return (
                      <div className="shop_items_subs">
                        <Dropdown.Item
                          onClick={() => {
                            navigate({
                              pathname: "/Product",
                              search: createSearchParams({
                                q: itemCat.id,
                              }).toString(),
                            });
                          }}
                          style={{
                            display: "flex",
                            gap: "10px",
                            fontSize: "16px",
                            marginBottom: "15px",
                            alignItems: "center",
                          }}
                        >
                          <>
                            <img
                              style={{ width: "40px" }}
                              src={itemCat.image}
                              alt=""
                            />
                            <p style={{ margin: "0px", fontSize: "14px" }}>
                              {language?.toLowerCase() == "ar"
                                ? itemCat?.title_ar
                                : itemCat?.title_en}
                            </p>
                          </>
                        </Dropdown.Item>
                        
                        {itemCat?.subcategories &&
                          itemCat?.subcategories.length &&
                          itemCat?.subcategories && (
                            <div className="all_cats_subs">
                              {Array.from(
                                {
                                  length: Math.ceil(
                                    itemCat.subcategories.length / 4
                                  ),
                                },
                                (_, index) => (
                                  <div key={index} className="column">
                                    {itemCat.subcategories
                                      .slice(index * 4, (index + 1) * 4)
                                      .map((subItem) => (
                                        <div
                                          key={subItem.id}
                                          onClick={() => {
                                            navigate({
                                              pathname: "/Product",
                                              search: createSearchParams({
                                                q: itemCat.id,
                                                s: subItem.id,
                                              }).toString(),
                                            });
                                          }}
                                          className="sub_item"
                                        >
                                          <h5 style={{ margin: '0px' }}>
                                            {language == 'ar'
                                              ? subItem.title_ar
                                              : subItem.title_en}
                                          </h5>
                                        </div>
                                      ))}
                                  </div>
                                )
                              )}
                            </div>
                          )}
                      </div>
                    );
                  }
                  return null;
                })
              : null}
              </div>
          </div>
          {/* <Dropdown.Menu
          className="sub_category_drop"
            style={{ height: "50vh", overflowY: "auto", width: "400px" }}
          >

          </Dropdown.Menu> */}
        </Dropdown>
        {categories && categories?.length
          ? categories?.map((itemCat, index) => {
              if (index <= 6) {
                return (
                  <div className="cat_and_sub">
                    <span
                      onMouseEnter={() => {
                        ;
                        // let allCategories=
                      }}
                      onClick={() => {
                        navigate({
                          pathname: "/Product",
                          search: createSearchParams({ q: itemCat.id }).toString(),
                        });
                      }}
                      className="category cat_for_sub subCatSub"
                      style={{ display: "flex" }}
                    >
                      <span className="dbot">.</span>
                      <span>
                        {" "}
                        {language?.toLowerCase() == "ar"
                          ? itemCat?.title_ar
                          : itemCat?.title_en}
                      </span>
                    </span>
                    {itemCat?.subcategories && itemCat?.subcategories.length && (
                      <div className="category_subcategories">
                         {itemCat?.subcategories &&
                          itemCat?.subcategories.length &&
                          itemCat?.subcategories && (
                            <div className="all_cats_subs">
                              {Array.from(
                                {
                                  length: Math.ceil(
                                    itemCat.subcategories.length / 4
                                  ),
                                },
                                (_, index) => (
                                  <div key={index} className="column">
                                    {itemCat.subcategories
                                      .slice(index * 4, (index + 1) * 4)
                                      .map((subItem) => (
                                        <div
                                          key={subItem.id}
                                          onClick={() => {
                                            navigate({
                                              pathname: "/Product",
                                              search: createSearchParams({
                                                q: itemCat.id,
                                                s: subItem.id,
                                              }).toString(),
                                            });
                                          }}
                                          className="sub_item"
                                        >
                                          <h5 style={{ margin: '0px' }}>
                                            {language == 'ar'
                                              ? subItem.title_ar
                                              : subItem.title_en}
                                          </h5>
                                        </div>
                                      ))}
                                  </div>
                                )
                              )}
                            </div>
                          )}
                      </div>
                    )}
                  </div>
                );
              }
              return null;
            })
          : null}

        {/* <div class="dropdown">
            <button style={{border:'none',display:'flex',gap:'4px'}} class="btn bg-transparent btn-secondary dropdown-toggle" type="button" id="dropdownMenu2" data-bs-toggle="dropdown" aria-expanded="false">
              {
                language=='ar'?
                <div className="d-flex">
                  <img src={require('../../../assets/Vector.png')} alt="" />
                  <span className="category">
                    كل المنتجات
                  </span>
                </div>
                :
                <>
                  <img src={require('../../../assets/Vector.png')} alt="" />
                  <span className="category">
                    All Products
                  </span>
                </>
              }
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenu2">
            {categories && categories?.length
          ? categories?.map((item,index) => {
              if(true){
                return (
                  <span className="category">
                    {language?.toLowerCase() == "ar"
                      ? item?.title_ar
                      : item?.title_en}
                  </span>
                );
              }
              return null
            })
          : null}
            </ul>
          </div> */}
      </div>
    </div>
  );
};

export default BottomHeader;
